<template>
  <span class="prioritySelector">
    <!--Read Only-->
    <span class="priorityIcon" :class="value" v-if="readOnly"></span>

    <!--Selector-->
    <v-popover
      placement="bottom"
      popoverClass="prioritySelectorPopover"
      v-else>

      <span class="tooltip-target cursor-pointer">
        <span class="priorityIcon" :class="value"></span>
      </span>

      <template slot="popover">
        <!--Loop each option-->
        <a class="priorityChoice" v-for="priority in priorities" :key="priority" @click="handleSubmit(priority)">
          <span class="priorityIcon" :class="priority" v-close-popover></span>
        </a>
        <!--Empty choice, for un-setting the value-->
        <a class="priorityChoice">
          <span class="priorityIcon" @click="handleSubmit(null)" v-close-popover></span>
        </a>
      </template>
    </v-popover>
  </span>
</template>

<script>
export default {
  props: {
    value: String,
    readOnly: Boolean
  },
  data () {
    return {
      priorities: ['GREEN', 'YELLOW', 'RED']
    }
  },
  methods: {
    handleSubmit (priority) {
      this.$emit('change', priority)
    }
  }
}
</script>

<style lang="scss">
@import "../../style/settings";

.priorityIcon {
  display: inline-block;
  width: 1.6rem;
  height: 1.6rem;
  background-color: white;
  border: 2px solid $border-color;
  border-radius: 50%;
  overflow: hidden;

  &.GREEN {
    background-color: #6CCB04;
  }
  &.YELLOW {
    background-color: #ffae00;
  }
  &.RED {
    background-color: #cc5656;
  }
}

.prioritySelector {
  .trigger:focus {
    outline: 0;
  }

  div.v-popover {
    display: inline-block;
  }
}

.prioritySelectorPopover {
  &.tooltip {
    min-width: 0;
    padding: .4rem;
  }

  .priorityChoice {
    display: block;
    padding: 0.2rem;

    &:hover .priorityIcon {
      border-color: darken($border-color, 25%);
    }
  }
}
</style>
